import type { ContenidoAyuda } from "@/ui/AyudaVista";
import { FICHAS_CASO } from "./fichasCaso";

/**
 * Ayuda de la vista Casos (botón «Ayuda» junto al título). Lo que antes iba en
 * tooltips de botones, filtros y fichas.
 */
export function ayudaCasos(nombreEmpresa: string): ContenidoAyuda {
  return {
    manual: "casos",
    intro: (
      <p>
        Todos los casos del equipo. <b>Activos</b> son los que siguen vivos (cualquier estado
        menos Cerrado); <b>Histórico</b>, los cerrados.
      </p>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "+ Nuevo caso",
            text: "Abre el formulario para crear un caso y, al guardarlo, te lleva directo a él. Sale gris si tu rol es de solo consulta.",
          },
          {
            label: "Activos / Histórico",
            text: "Cambia entre los casos vivos y los cerrados. El número entre paréntesis es cuántos hay con los filtros que tienes puestos.",
          },
          {
            label: "Una fila o tarjeta",
            text: "Tócala en cualquier parte para abrir el caso. Con Ctrl (o ⌘) + clic en el folio se abre en otra pestaña.",
          },
          {
            label: "Nombre del cliente",
            text: "Tócalo para ver solo los casos de esa empresa. Se quita con la ✕ de la ficha «Cliente: …».",
          },
          {
            label: "+N más",
            text: "El caso trae más de tres equipos: tócalo para ver todos sus IMEIs ahí mismo, y «ver menos» para plegarlos.",
          },
          {
            label: "Filtros (celular)",
            text: "En el celular los filtros viven en este botón; el número es cuántos tienes puestos. Cada filtro activo sale como ficha arriba de la lista: tócala para quitarlo, o «Limpiar todo».",
          },
          {
            label: "Expandir todo / Colapsar todo",
            text: "Con «Agrupar por cliente», abre o cierra todas las secciones de un jalón.",
          },
          { label: "← Anterior / Siguiente →", text: "Cambia de página cuando la lista no cabe en una." },
        ],
      },
      {
        titulo: "Filtros y orden",
        items: [
          {
            label: "Buscador",
            text: "Busca en el cliente y sus contactos (nombre y correo), el folio, el TE, el número de ticket de Jimi, el IMEI, la marca, el modelo y la descripción del caso. No distingue mayúsculas ni acentos. El número de ticket de Queclink no se busca aquí.",
          },
          { label: "Estado", text: "Solo los casos en ese estado." },
          { label: "Agrupar por cliente", text: "Junta los casos en secciones plegables, una por empresa." },
          {
            label: "Solo los que esperan mi respuesta",
            text: "Solo los casos donde un compañero te mencionó y todavía falta tu respuesta.",
          },
          { label: "Solo con equipo crítico", text: "Solo los casos con al menos un equipo marcado como Crítico." },
          {
            label: "El proveedor ya contestó",
            text: "Solo los casos donde Jimi o Queclink ya respondieron en su ticket y nosotros todavía no.",
          },
          { label: "Asesor comercial", text: "Solo los casos de las empresas que atiende ese asesor." },
          { label: "Marca", text: "Solo los casos de esa marca de equipo." },
          {
            label: "Ordenar",
            text: "Recién creados, más antiguos, más estancados (los que llevan más días sin movimiento) o movidos hace poco. Los dos últimos solo existen en Activos.",
          },
          {
            label: "Posesión",
            text: `Solo en Activos. «Míos»: los asignados a ti. «${nombreEmpresa}»: la pelota la tenemos nosotros. «Cliente»: esperamos al cliente. «Proveedor»: está con el proveedor. El número es cuántos hay.`,
          },
          {
            label: "Desde estadísticas: …",
            text: "Filtro que llegó al tocar una barra en Estadísticas. Tócalo para quitarlo.",
          },
        ],
      },
      { titulo: "Qué significa cada ficha", items: FICHAS_CASO },
      {
        titulo: "Atajos de teclado",
        items: [
          { label: "/", text: "Pone el cursor en el buscador." },
          {
            label: "j / k",
            text: "Bajan y suben por la lista; Enter abre el caso marcado. Solo con la lista sin agrupar.",
          },
        ],
      },
    ],
  };
}
